import React, { useEffect, useState } from "react";
import { post } from "../../apiService";
import {
  Form,
  Button,
  Steps,
  Divider,
  ConfigProvider,
  message,
  notification,
} from "antd";
import Header from "../Header";
import Account from "./Account";
import Profile from "./Profile";
import Company from "./Company";
import Finish from "./Finish";
import { Link, useNavigate } from "react-router-dom";
import "../Registration/Registration.css";
import moment from "moment";

const Registration = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [calVal, setcalVal] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const [isUsernameAvailable, setIsUsernameAvailable] = useState(false);
  const [isPhoneNumberAvailable, setIsPhoneNumberAvailable] = useState(false);
  const [isEmailAvailable, setIsEmailAvailable] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    name: "",
    confirmPassword: "",
    email: "",
    country: "",
    phoneNumber: "",
    referedBy: "",
    // Add other fields as needed
    // Profile fields
    gender: "", // Default gender value
    dob: "",
    addressOne: "",
    addressTwo: "",
    city: "",
    state: "",
    zipCode: "",
    // Company fields
    representingCompany: 1,
    companyName: "",
    website: "",
    businessActivity: "",
    businessReletionshipPeriod: "",
    promoterName: "",
    businessRegistrationNo: "",
    // Finish fields
    terms: false,
  });
  const steps = [
    {
      title: "Account",
      content: (
        <Account
          form={form}
          setVerifyEmail={setVerifyEmail}
          verifyEmail={verifyEmail}
          formData={formData}
          setFormData={setFormData}
          setIsEmailAvailable={setIsEmailAvailable}
          setIsPhoneNumberAvailable={setIsPhoneNumberAvailable}
          setIsUsernameAvailable={setIsUsernameAvailable}
          isEmailAvailable={isEmailAvailable}
          isPhoneNumberAvailable={isPhoneNumberAvailable}
          isUsernameAvailable={isUsernameAvailable}
        />
      ),
    },
    {
      title: "Profile",
      content: (
        <Profile form={form} formData={formData} setFormData={setFormData} />
      ),
    },
    {
      title: "Company",
      content: (
        <Company form={form} formData={formData} setFormData={setFormData} />
      ),
    },
    {
      title: "Finish",
      content: (
        <Finish
          form={form}
          formData={formData}
          setFormData={setFormData}
          setcalVal={setcalVal}
        />
      ),
    },
  ];

  const next = () => {
    form
      .validateFields()
      .then(() => {
        if (current === 0 && !verifyEmail) {
          message.error("Please verify your email first.");
        } else {
          setCurrent(current + 1);
        }
      })
      .catch((errorInfo) => {
        console.log("Failed:", errorInfo);
      });
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const onFinish = async (values) => {
    // console.log("registation capthcha" +calVal)
    console.log("values " + JSON.stringify(values));
    if (!formData.terms || calVal === null) {
      // console.log('Success:', formData);
      // console.log('Success:', formData)
      // console.log(form.getFieldValue())
      // const apiEndpoint = 'https://your-api-endpoint.com/submit';
      message.error("please checked all field");
      return;
    }
    // const allFormData = form.getFieldValue()

    console.log(form.getFieldValue());
    setLoading(true);
    const formDataToSend = new FormData();
    formDataToSend.append("name", form.getFieldValue("name"));
    formDataToSend.append("user_email", form.getFieldValue("email"));
    formDataToSend.append("address_one", form.getFieldValue("addressOne"));
    formDataToSend.append("address_two", form.getFieldValue("addressTwo"));
    formDataToSend.append("city", form.getFieldValue("city"));
    formDataToSend.append("user_password", form.getFieldValue("password"));
    formDataToSend.append("number", form.getFieldValue("phoneNumber"));
    formDataToSend.append("refer_by", form.getFieldValue("referedBy"));
    formDataToSend.append("state", form.getFieldValue("state"));
    formDataToSend.append("user_name", form.getFieldValue("username"));
    formDataToSend.append("zip_code", form.getFieldValue("zipCode"));
    formDataToSend.append("compney_name", form.getFieldValue("companyName"));
    formDataToSend.append("website", form.getFieldValue("website"));
    formDataToSend.append(
      "business_activity",
      form.getFieldValue("businessActivity")
    );
    formDataToSend.append(
      "business_relation_ship_period",
      form.getFieldValue("businessReletionshipPeriod")
    );
    formDataToSend.append("promoter_name", form.getFieldValue("promoterName"));
    formDataToSend.append(
      "business_registrarion_no",
      form.getFieldValue("businessRegistrationNo")
    );
    formDataToSend.append("gender", form.getFieldValue("gender"));
    formDataToSend.append(
      "dob",
      moment(form.getFieldValue("dob")).format("YYYY-MM-DD")
    );
    formDataToSend.append("action", "sendSignupWelcomeEmail");
    formDataToSend.append("country", form.getFieldValue("country"));
    console.log(formDataToSend);

    try {
      const response = await post("/user.php", formDataToSend);

      // const result = response.data;
      // console.log(result);

      if (response) {
        // message.success('Registration successfully!');
        // openNotification('top');
        message.success("Registration successfully!");
        navigate("/login");
        // message.success('Email verified successfully!');
      } else {
        message.error(response?.message || "Email already exists.");
      }
    } catch (error) {
      console.error("Error details:", error);

      // if (error.response) {
      //     // The request was made and the server responded with a status code that falls out of the range of 2xx
      //     if (error.response.status === 400) {
      //         // Handle 400 Bad Request
      //         message.error(error.response.data.message || 'Bad Request: Check your input.');
      //     } else {
      //         message.error(error.response.data.message || 'Failed to verify email.');
      //     }
      // } else if (error.request) {
      //     // The request was made but no response was received
      //     message.error('No response received from the server.');
      // } else {
      // Something happened in setting up the request that triggered an Error
      // openNotification('top');
      // navigate('/login');
      message.error("An error occurred while verifying the email.");
      // }
    } finally {
      setLoading(false);
    }
    // Add your API submission logic here
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // Account start
  const [countries, setCountries] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchCountries();
    }, 500);
    return () => clearTimeout(dbounce);
  }, []);

  const fetchCountries = async () => {
    try {
      const response = await fetch(
        "https://restcountries.com/v3.1/all?fields=name"
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setCountries(data);
    } catch (error) {
      setError(error);
    }
  };
  // Account End

  return (
    <>
      {contextHolder}
      <ConfigProvider
        theme={{
          token: {
            borderRadius: "0",
            // paddingLG: "100px",
          },
        }}
      >
        <section className="account_page">
          <div className="container">
            <div className="registration-outer-main-div account-box">
              <h5 className="login-title"> User Registration</h5>
              <Divider />
              <Steps
                current={current}
                items={steps?.map((item) => ({
                  key: item.title,
                  title: item.title,
                }))}
              />
              <Divider />
              <div className="registration-input-field-main">
                <Form
                  form={form}
                  layout="vertical"
                  name="registration"
                  autoComplete="off"
                  initialValues={{ remember: true }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                >
                  <div className="row">{steps[current].content}</div>
                  <div style={{ marginTop: 24 }}>
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: "20px",
                          colorPrimary: "#217DC1",
                        },
                      }}
                    >
                      {current < steps.length - 1 && (
                        <Button type="primary" onClick={next}>
                          Next
                        </Button>
                      )}
                      {current === steps.length - 1 && (
                        <Button
                          loading={loading}
                          disabled={loading}
                          type="primary"
                          htmlType="submit"
                        >
                          {loading ? "Creating Account ..." : "Submit"}
                        </Button>
                      )}

                      {current > 0 && (
                        <Button style={{ margin: "0 8px" }} onClick={prev}>
                          Previous
                        </Button>
                      )}
                    </ConfigProvider>
                  </div>
                </Form>
              </div>
              <Link to="/login">
                <h6 className="text-center dont-have-an-account">
                  Already have an account?{" "}
                  <span style={{ color: "blue", cursor: "pointer" }}>
                    Login
                  </span>{" "}
                </h6>
              </Link>
            </div>
          </div>
        </section>
      </ConfigProvider>
    </>
  );
};

export default Registration;
